module.exports = __webpack_public_path__ + "img/frame-2.115b1004.png";